import React, { useState, useEffect } from 'react';
import './userPlans.css';
import { Row, Col } from 'react-bootstrap';
import { FaCheck, FaChevronRight } from 'react-icons/fa';
import DynamicBreadcrumbs from '../dynamic_breadcumb/dynamic_breadcrumb';
import allPlansData from '../../API/Resources/premium_plans/plans.json';
import DownloadAppUI from '../../ui_components/download_app/download_app';
import SiteFooter from '../../ui_components/site_footer/site_footer';
import FAQ from '../../ui_components/faq_component/FAQ';

export default function UserPlans({ homepage }) {
  const [plansToDisplay, setPlansToDisplay] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    const role = localStorage.getItem('role') || 'user';

    let selectedPlans = [];
    if (role === 'USER') {
      selectedPlans = allPlansData.userPlans;
      setTitle('User Packages');
    } else if (role === 'VENDOR') {
      selectedPlans = allPlansData.vendorPlans;
      setTitle('Vendor Packages');
    }
    else {
      selectedPlans = allPlansData.userPlans;
      setTitle('User Packages');
    }

    const sortedPlans = selectedPlans.sort((a, b) => a.sortOrder - b.sortOrder);

    setPlansToDisplay(sortedPlans);
  }, []);

  return (
    <div className="container my-2 py-2 user-plans-container">
      {!homepage && <DynamicBreadcrumbs />}
      <h2 className="plans-title mb-0 mt-3">{title}</h2>
      <Row className="g-4 m-0 justify-content-center h-auto">
        {plansToDisplay.map((plan) => (
          <Col md={12} lg={4} key={plan.id}>
            {/* Add a 'popular' class conditionally for styling */}
            <div className={`plan-card ${plan.popular ? 'popular' : ''}`}>
              <div className="plan-header">
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-description">{plan.description}</p>
                <div className="plan-price">
                  <span className="current-price">{plan.price[0]}</span><br />
                  {plan.price[1] && (
                    <span className="secondary-price">{plan.price[1]}</span>
                  )}
                </div>
              </div>
              <ul className="plan-features list-unstyled">
                {plan.features.map((feature, i) => (
                  <li key={`${plan.id}-feature-${i}`}>
                    <FaCheck className="check-icon" /> {feature}
                  </li>
                ))}
              </ul>
              <div className="continue-link-container text-end">
                <a href="#" className="continue-link">Continue <FaChevronRight /></a>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      {!homepage && <section className="my-5">
        {/* FAQ */}
        <div>
          <FAQ />
        </div>
        {/* Download the app */}
        <div id='download-app-container' className='m-0'>
          <DownloadAppUI />
        </div>

        {/* Site Footer */}
        <div>
          <SiteFooter />
        </div>
      </section>
      }
    </div>
  );
}